import type { UserStatus } from '../components/UserStatusBadge'
import type { MemberDetails, TeamMemberDto } from './teamMembers.types'

export interface TeamMemberRow {
  id: string
  name: string
  email: string
  role: string
  status: UserStatus
  joinDate: string
  _raw: TeamMemberDto
}

const STATUS_MAP: Record<string, UserStatus> = {
  active: 'Active',
  pending: 'Pending',
  expired: 'Expired',
  deactivated: 'Deactivated',
}

function mapStatus(api: string): UserStatus {
  return STATUS_MAP[api.toLowerCase()] ?? 'Pending'
}

function displayRole(role: string): string {
  const u = role.toUpperCase()
  if (u === 'EDITOR') return 'Editor'
  if (u === 'VIEWER') return 'Viewer'
  return role
}

function formatJoinLabel(d?: string | null): string {
  if (!d) return 'N/A'
  const date = new Date(d)
  if (Number.isNaN(date.getTime())) return 'N/A'
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function mapTeamMemberToRow(dto: TeamMemberDto): TeamMemberRow {
  const joinSource = dto.joinDate ?? null
  return {
    id: dto.sensemakerId?.trim() || 'N/A',
    name: [dto.firstName, dto.lastName].filter(Boolean).join(' ').trim() || '—',
    email: dto.email,
    role: displayRole(dto.role),
    status: mapStatus(dto.status),
    joinDate: formatJoinLabel(joinSource),
    _raw: dto,
  }
}

export function mapTeamMemberDtoToMemberDetails(dto: TeamMemberDto): MemberDetails {
  const row = mapTeamMemberToRow(dto)
  return {
    id: row.id,
    firstName: dto.firstName,
    lastName: dto.lastName,
    email: dto.email,
    joinDate: row.joinDate,
    role: row.role,
    status: row.status,
  }
}
